// Country flag utility for displaying flags based on country code
// Maps 2-letter country codes to flag emojis

const COUNTRY_FLAGS = {
  IN: { flag: '🇮🇳', name: 'India' },
  US: { flag: '🇺🇸', name: 'United States' },
  GB: { flag: '🇬🇧', name: 'United Kingdom' },
  DE: { flag: '🇩🇪', name: 'Germany' },
  CN: { flag: '🇨🇳', name: 'China' },
  AE: { flag: '🇦🇪', name: 'United Arab Emirates' },
  SG: { flag: '🇸🇬', name: 'Singapore' },
  JP: { flag: '🇯🇵', name: 'Japan' },
  VN: { flag: '🇻🇳', name: 'Vietnam' },
  ID: { flag: '🇮🇩', name: 'Indonesia' },
  DZ: { flag: '🇩🇿', name: 'Algeria' },
  AR: { flag: '🇦🇷', name: 'Argentina' },
  AU: { flag: '🇦🇺', name: 'Australia' },
  AT: { flag: '🇦🇹', name: 'Austria' },
  BH: { flag: '🇧🇭', name: 'Bahrain' },
  BD: { flag: '🇧🇩', name: 'Bangladesh' },
  BE: { flag: '🇧🇪', name: 'Belgium' },
  BR: { flag: '🇧🇷', name: 'Brazil' },
  CM: { flag: '🇨🇲', name: 'Cameroon' },
  CA: { flag: '🇨🇦', name: 'Canada' },
  CL: { flag: '🇨🇱', name: 'Chile' },
  CO: { flag: '🇨🇴', name: 'Colombia' },
  CZ: { flag: '🇨🇿', name: 'Czech Republic' },
  DK: { flag: '🇩🇰', name: 'Denmark' },
  EG: { flag: '🇪🇬', name: 'Egypt' },
  ET: { flag: '🇪🇹', name: 'Ethiopia' },
  FI: { flag: '🇫🇮', name: 'Finland' },
  FR: { flag: '🇫🇷', name: 'France' },
  GH: { flag: '🇬🇭', name: 'Ghana' },
  GR: { flag: '🇬🇷', name: 'Greece' },
  HU: { flag: '🇭🇺', name: 'Hungary' },
  IE: { flag: '🇮🇪', name: 'Ireland' },
  IL: { flag: '🇮🇱', name: 'Israel' },
  IT: { flag: '🇮🇹', name: 'Italy' },
  CI: { flag: '🇨🇮', name: 'Ivory Coast' },
  JO: { flag: '🇯🇴', name: 'Jordan' },
  KE: { flag: '🇰🇪', name: 'Kenya' },
  KW: { flag: '🇰🇼', name: 'Kuwait' },
  MY: { flag: '🇲🇾', name: 'Malaysia' },
  MX: { flag: '🇲🇽', name: 'Mexico' },
  MA: { flag: '🇲🇦', name: 'Morocco' },
  NP: { flag: '🇳🇵', name: 'Nepal' },
  NL: { flag: '🇳🇱', name: 'Netherlands' },
  NZ: { flag: '🇳🇿', name: 'New Zealand' },
  NG: { flag: '🇳🇬', name: 'Nigeria' },
  NO: { flag: '🇳🇴', name: 'Norway' },
  OM: { flag: '🇴🇲', name: 'Oman' },
  PK: { flag: '🇵🇰', name: 'Pakistan' },
  PE: { flag: '🇵🇪', name: 'Peru' },
  PH: { flag: '🇵🇭', name: 'Philippines' },
  PL: { flag: '🇵🇱', name: 'Poland' },
  PT: { flag: '🇵🇹', name: 'Portugal' },
  QA: { flag: '🇶🇦', name: 'Qatar' },
  RO: { flag: '🇷🇴', name: 'Romania' },
  RU: { flag: '🇷🇺', name: 'Russia' },
  RW: { flag: '🇷🇼', name: 'Rwanda' },
  SA: { flag: '🇸🇦', name: 'Saudi Arabia' },
  SN: { flag: '🇸🇳', name: 'Senegal' },
  ZA: { flag: '🇿🇦', name: 'South Africa' },
  KR: { flag: '🇰🇷', name: 'South Korea' },
  ES: { flag: '🇪🇸', name: 'Spain' },
  LK: { flag: '🇱🇰', name: 'Sri Lanka' },
  SE: { flag: '🇸🇪', name: 'Sweden' },
  CH: { flag: '🇨🇭', name: 'Switzerland' },
  TZ: { flag: '🇹🇿', name: 'Tanzania' },
  TH: { flag: '🇹🇭', name: 'Thailand' },
  TN: { flag: '🇹🇳', name: 'Tunisia' },
  TR: { flag: '🇹🇷', name: 'Turkey' },
  UG: { flag: '🇺🇬', name: 'Uganda' },
  UA: { flag: '🇺🇦', name: 'Ukraine' },
  OTHER: { flag: '🌐', name: 'Other' }
};

// Map full country names to codes
const COUNTRY_NAME_TO_CODE = {
  'india': 'IN',
  'united states': 'US',
  'usa': 'US',
  'united kingdom': 'GB',
  'uk': 'GB',
  'germany': 'DE',
  'china': 'CN',
  'united arab emirates': 'AE',
  'uae': 'AE',
  'singapore': 'SG',
  'japan': 'JP',
  'vietnam': 'VN',
  'indonesia': 'ID',
  'algeria': 'DZ',
  'argentina': 'AR',
  'australia': 'AU',
  'austria': 'AT',
  'bahrain': 'BH',
  'bangladesh': 'BD',
  'belgium': 'BE',
  'brazil': 'BR',
  'cameroon': 'CM',
  'canada': 'CA',
  'chile': 'CL',
  'colombia': 'CO',
  'czech republic': 'CZ',
  'denmark': 'DK',
  'egypt': 'EG',
  'ethiopia': 'ET',
  'finland': 'FI',
  'france': 'FR',
  'ghana': 'GH',
  'greece': 'GR',
  'hungary': 'HU',
  'ireland': 'IE',
  'israel': 'IL',
  'italy': 'IT',
  'ivory coast': 'CI',
  'jordan': 'JO',
  'kenya': 'KE',
  'kuwait': 'KW',
  'malaysia': 'MY',
  'mexico': 'MX',
  'morocco': 'MA',
  'nepal': 'NP',
  'netherlands': 'NL',
  'new zealand': 'NZ',
  'nigeria': 'NG',
  'norway': 'NO',
  'oman': 'OM',
  'pakistan': 'PK',
  'peru': 'PE',
  'philippines': 'PH',
  'poland': 'PL',
  'portugal': 'PT',
  'qatar': 'QA',
  'romania': 'RO',
  'russia': 'RU',
  'rwanda': 'RW',
  'saudi arabia': 'SA',
  'senegal': 'SN',
  'south africa': 'ZA',
  'south korea': 'KR',
  'spain': 'ES',
  'sri lanka': 'LK',
  'sweden': 'SE',
  'switzerland': 'CH',
  'tanzania': 'TZ',
  'thailand': 'TH',
  'tunisia': 'TN',
  'turkey': 'TR',
  'uganda': 'UG',
  'ukraine': 'UA'
};

/**
 * Get country flag emoji from country code or name
 * @param {string} countryCodeOrName - 2-letter code (IN, US) or full name (India, United States)
 * @returns {string} Flag emoji or globe emoji if not found
 */
export function getCountryFlag(countryCodeOrName) {
  if (!countryCodeOrName) return '🌐';
  
  // Check if it's already a 2-letter code
  const upperCode = countryCodeOrName.toUpperCase();
  if (COUNTRY_FLAGS[upperCode]) {
    return COUNTRY_FLAGS[upperCode].flag;
  }
  
  // Try to find by name
  const lowerName = countryCodeOrName.toLowerCase();
  const code = COUNTRY_NAME_TO_CODE[lowerName];
  if (code && COUNTRY_FLAGS[code]) {
    return COUNTRY_FLAGS[code].flag;
  }
  
  return '🌐';
}

/**
 * Get country name from code
 * @param {string} code - 2-letter country code
 * @returns {string} Country name or the code itself if not found
 */
export function getCountryName(code) {
  if (!code) return '';
  const upperCode = code.toUpperCase();
  return COUNTRY_FLAGS[upperCode]?.name || code;
}

/**
 * Get both flag and name formatted
 * @param {string} countryCodeOrName - Country code or name
 * @returns {object} { flag, name, display }
 */
export function getCountryInfo(countryCodeOrName) {
  if (!countryCodeOrName) {
    return { flag: '🌐', name: 'Unknown', display: '🌐 Unknown' };
  }
  
  // Check if it's a 2-letter code
  const upperCode = countryCodeOrName.toUpperCase();
  if (COUNTRY_FLAGS[upperCode]) {
    const { flag, name } = COUNTRY_FLAGS[upperCode];
    return { flag, name, display: `${flag} ${name}` };
  }
  
  // Try to find by name
  const lowerName = countryCodeOrName.toLowerCase();
  const code = COUNTRY_NAME_TO_CODE[lowerName];
  if (code && COUNTRY_FLAGS[code]) {
    const { flag, name } = COUNTRY_FLAGS[code];
    return { flag, name, display: `${flag} ${name}` };
  }
  
  // Fallback - just use what was provided
  return { flag: '🌐', name: countryCodeOrName, display: `🌐 ${countryCodeOrName}` };
}

// React component for displaying country flag with optional name
export function CountryFlag({ country, showName = false, size = 'md', className = '' }) {
  const { flag, name } = getCountryInfo(country);
  
  const sizeClasses = {
    sm: 'text-base',
    md: 'text-lg',
    lg: 'text-2xl',
    xl: 'text-3xl'
  };
  
  return (
    <span className={`inline-flex items-center gap-1 ${className}`} title={name}>
      <span className={sizeClasses[size] || sizeClasses.md}>{flag}</span>
      {showName && <span className="text-sm">{name}</span>}
    </span>
  );
}

export default { getCountryFlag, getCountryName, getCountryInfo, CountryFlag, COUNTRY_FLAGS };
